import {Component, OnInit, Inject, ViewEncapsulation, AfterViewInit, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {CommonService} from 'src/app/core/services/common.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html',
  encapsulation: ViewEncapsulation.None
})

export class ViewFilePdfComponent implements OnInit, AfterViewInit, OnDestroy {

  filePathBase64: string;
  fileName: string;
  authorization: any;
  public language: string;
  subscriptions: Subscription = new Subscription();

  constructor(
    private commonService: CommonService,
    public dialogRef: MatDialogRef<ViewFilePdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      dialogRef.disableClose = false;
      this.filePathBase64 = data.filePathBase64;
      this.fileName = data.fileName;
      this.authorization = {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
      this.language = localStorage.getItem("__language") || "vi";
  }

  ngOnInit() {
    this.subscriptions.add(
      this.commonService.getCurrentLanguage().subscribe((lang) => {
        if (lang !== this.language) {
          location.reload();
        }
      })
    );
  }

  ngOnDestroy(): void {

  }

  ngAfterViewInit() {

  }

}
